import {
  Box,
  Button,
  Tabs,
  Tab,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import React, { useState } from "react";
import SearchBar from "../../components/SearchBar";
import AddIcon from "@mui/icons-material/Add";
import SwitchToggle from "../../components/SwitchToggle";
import AddTypeFlavor from "../../Modals/addTypeFlavor";
import AddTypeTopping from "../../Modals/addTypeTopping";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const YogurtTypeDetail = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");

  const [value, setValue] = React.useState(0);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const [openModal, setOpenModal] = useState(false);
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const [openModal1, setOpenModal1] = useState(false);
  const handleCloseModal1 = () => {
    setOpenModal1(false);
  };

  const [rows] = useState([
    {
      id: 1,
      name: "Classic Vanilla",
      method: '0.95',
      status: true,
    }
  ]);

  const [rows1] = useState([
    {
      id: 1,
      name: "Fresh Strawberries",
      method: '0.50',
      status: true,
    }
  ]);

  return (
    <>
      <div className="main_title">
        <h1>Frozen Greek Yogurt</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> - <button onClick={() => navigate("/manage-yogurt-types")}>Yogurt Types</button> - Detail
        </p>
      </div>

      {/* Tabs */}
      <Box className="custom_tabs1">
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" className="custom_tabs_links">
          <Tab label="Flavors Management" {...a11yProps(0)} />
          <Tab label="Toppings Management" {...a11yProps(1)} />
        </Tabs>
      </Box>

      {/* Table */}
      <div className="cards mt_20">
        <CustomTabPanel value={value} index={0}>
          <div className="table_header">
            <div className="left_s">
              <SearchBar
                searchTerm={searchTerm}
                setDebouncedSearchTerm={setSearchTerm}
                placeholder="Search..."
              />
            </div>
            <div className="right_s">
              <Button
                className="btn btn_primary"
                onClick={() => setOpenModal(true)}
              >
                <AddIcon /> Add Flavor
              </Button>
            </div>
          </div>

          <TableContainer className="table_container">
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Name</TableCell>
                  <TableCell>Price per 100g (OMR)</TableCell>
                  <TableCell>Featured</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {rows.map((row, index) => (
                  <TableRow hover key={row.id}>
                    <TableCell>
                      <Box component="a" className="user_block"
                      >
                        <figure>
                          <img src="/static/images/placeholder.png" alt="User" />
                        </figure>
                        <p>
                          <b>{row.name}</b>
                        </p>
                      </Box>
                    </TableCell>
                    <TableCell>{row.method}</TableCell>
                    <TableCell><SwitchToggle /></TableCell>
                    <TableCell><SwitchToggle /></TableCell>
                    <TableCell>
                      <div className="table_actions v2">
                        <IconButton onClick={() => setOpenModal(true)}>
                          <img src="/static/images/edit2_icon.svg" alt="Edit" />
                        </IconButton>
                        <IconButton>
                          <img src="/static/images/trash2_icon.svg" alt="Delete" />
                        </IconButton>
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </CustomTabPanel>

        <CustomTabPanel value={value} index={1}>
          <div className="table_header">
            <div className="left_s">
              <SearchBar
                searchTerm={searchTerm}
                setDebouncedSearchTerm={setSearchTerm}
                placeholder="Search..."
              />
            </div>
            <div className="right_s">
              <Button
                className="btn btn_primary"
                onClick={() => setOpenModal1(true)}
              >
                <AddIcon /> Add Toppings
              </Button>
            </div>
          </div>

          <TableContainer className="table_container">
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Name</TableCell>
                  <TableCell>Price (OMR)</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {rows1.map((row, index) => (
                  <TableRow hover key={row.id}>
                    <TableCell>{row.name}</TableCell>
                    <TableCell>{row.method}</TableCell>
                    <TableCell>
                      <SwitchToggle />
                    </TableCell>
                    <TableCell>
                      <div className="table_actions v2">
                        <IconButton onClick={() => setOpenModal1(true)}>
                          <img src="/static/images/edit2_icon.svg" alt="Edit" />
                        </IconButton>
                        <IconButton>
                          <img src="/static/images/trash2_icon.svg" alt="Delete" />
                        </IconButton>
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </CustomTabPanel>
      </div>

      <AddTypeFlavor
        open={openModal}
        onClose={handleCloseModal}
        setOpen={setOpenModal}
      />

      <AddTypeTopping
        open={openModal1}
        onClose={handleCloseModal1}
        setOpen={setOpenModal1}
      />
    </>
  );
};

export default YogurtTypeDetail;
